module.exports = __webpack_public_path__ + "img/q12.d84b91ba.jpeg";